// extracted by mini-css-extract-plugin
export default {"button":"FileButton_button__7gr3A"};